import { RpcError } from "grpc-web";
import { Track, UpdateSplitSheetDetailsRequest, UpdateSplitSheetDetailsResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";


export const updateSplitSheetDetails = async (
    token: string,
    track: Track
): Promise<RpcError | UpdateSplitSheetDetailsResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new UpdateSplitSheetDetailsRequest();
        request.setTrack(track);
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<UpdateSplitSheetDetailsResponse | RpcError>((resolve, reject) => {
                    ommuseClient.updateSplitSheetDetails(request, metadata, function (err, response) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(response);
                        }
                    });
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};